<template>
  <div>
    <v-row class="editInfo no-gutters align-center justify-space-start px-5 py-2">
      <!-- Código denuncia -->
      <v-col class="px-2 py-1" :class="$vuetify.breakpoint.smAndDown ? 'col-6' : 'pr-3 infoBlock'">
        <p class="editInfoLabel mb-0"> {{$t('datTableHeader.complaintId')}} </p>
        <p class="editInfoData mb-0"> {{dComplaintInfo.auxId}} </p>
      </v-col>
      <!-- Título denuncia -->
      <v-col class="px-2 py-1" :class="$vuetify.breakpoint.smAndDown ? 'col-6' : 'pr-3 infoBlock'">
        <p class="editInfoLabel mb-0"> {{$t('datTableHeader.title')}} </p>
        <p class="editInfoData mb-0"> {{dComplaintInfo.title}} </p>
      </v-col>
      <!-- Fecha Creación-->
      <v-col class="px-2 py-1" :class="$vuetify.breakpoint.smAndDown ? 'col-6' : 'pr-3 infoBlock'">
        <p class="editInfoLabel mb-0"> {{$t('datTableHeader.creationDate')}} </p>
        <p class="editInfoData mb-0"> {{fDateFormat(dComplaintInfo.creationDate)}} </p>
      </v-col>
      <!-- Denunciante -->
      <v-col class="px-2 py-1" :class="$vuetify.breakpoint.smAndDown ? 'col-6' : 'pr-3 infoBlock'">
        <p class="editInfoLabel mb-0"> {{$t('labels.creationUser')}} </p>
        <p class="editInfoData mb-0"> {{dComplaintInfo.userName}} </p>
      </v-col>
      <!-- Estado -->
      <v-col class="px-2 py-1" :class="$vuetify.breakpoint.smAndDown ? 'col-6' : 'pr-3 infoBlock'">
        <p class="editInfoLabel mb-0"> {{$t('datTableHeader.status')}} </p>
        <p class="editInfoData mb-0"> {{dComplaintInfo.status}} </p>
      </v-col>                  
    </v-row>
    <v-row class="editInfo no-gutters align-center justify-space-start px-5 py-2">
      <v-col class="px-2 py-1" :class="$vuetify.breakpoint.smAndDown ? 'col-6' : 'pr-3 infoBlock'">
        <v-stepper alt-labels class="wizard" >
          <v-stepper-header>
            <v-stepper-step step="1" :complete="fIsComplete(1)">{{fLabel(1)}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step v-if="dComplaintInfo.status  !== 'RECHAZADA'" step="2" :complete="fIsComplete(2)">{{fLabel(2)}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step v-if="dComplaintInfo.status  !== 'RECHAZADA'" step="3" :complete="fIsComplete(3)">{{fLabel(3)}}</v-stepper-step>
            <v-divider/>
            <v-stepper-step step="4" :complete="fIsComplete(4)">{{fLabel(4)}}</v-stepper-step>            
          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

export default {
  
  mixins: [mxCanalDenuncias],

  props: {
    pComplaintInfo:{
      type: Object,
      required: false,
    }
  },
  data () {
    return {
      dComplaintInfo:  global.structuredClone(this.pComplaintInfo),
    }
  },

  methods:{
    // Posibles estados: 'NUEVA','TRAMITE','TRAMITE_FP','RESUELTA','RECHAZADA','ACEPTADA','REABIERTA'
    fIsComplete(step){
      if( step === 1 &&
        (this.dComplaintInfo.status === 'NUEVA')){
          return true
      } else if ( step <= 2 && (this.dComplaintInfo.status === 'ACEPTADA' || this.dComplaintInfo.status  === 'REABIERTA') ){
          return true
      } else if ( step <= 3 && this.dComplaintInfo.status.includes('TRAMITE')){
          return true
      } else if ( step <= 4 && 
        (this.dComplaintInfo.status === 'RESUELTA'  ||
        this.dComplaintInfo.status  === 'RECHAZADA' )){
          return true
      } else {
        return false
      }
    },

    fLabel(step){ 
      let label = ''

      if( step === 1 ){
        label = this.$t('compDetails.step1')
      } else if ( step === 2 && this.dComplaintInfo.status === 'REABIERTA'){
        label = this.$t('compDetails.step2b')        
      } else if ( step === 2 && this.dComplaintInfo.status !== 'RECHAZADA'){
        label = this.$t('compDetails.step2')
      } else if ( step === 3 && this.dComplaintInfo.status === 'TRAMITE_FP'){
        label = this.$t('compDetails.step3a')
      } else if ( step === 3 && this.dComplaintInfo.status !== 'RECHAZADA'){
        label = this.$t('compDetails.step3b')          
      } else if ( step === 4 && this.dComplaintInfo.status === 'RECHAZADA'){
        label = this.$t('compDetails.step4b')
      } else if ( step === 4 ){
        label = this.$t('compDetails.step4a')                          
      } 
      return label
    }
  },

  watch: {
    pComplaintInfo:{
      deep: true,
      handler(){
        this.dComplaintInfo = global.structuredClone(this.pComplaintInfo)
      }
    }
  }
}
</script>
